import React, {useEffect, useState} from 'react';
import Link from 'next/link';
import _ from 'lodash';
import ImgTheme from '../ImgTheme';
import {IoCloseSharp} from 'react-icons/io5';

export default function Announce({
                                     type = 'success',
                                     singleRow = false,
                                     icon,
                                     title,
                                     text,
                                     className,
                                     innerClassName = '',
                                     textClassName = '',
                                     link = null,
                                     linkIcon = null,
                                     closable = false,
                                     onClose = undefined
                                 }) {
    const [showAnnounce, setShowAnnounce] = useState(true)

    const TYPES = {
        success: 0,
        error: 1,
        info: 2,
        warning: 3,
        normal: 4,
        ghost: 5,
    };

    const COLORS = {
        [TYPES.success]: 'success',
        [TYPES.error]: 'error',
        [TYPES.info]: 'info',
        [TYPES.warning]: 'warn',
        [TYPES.normal]: 'black',
        [TYPES.ghost]: 'transparent',
    };

    const TEXT_COLORS = {
        [TYPES.success]: 'text-success dark:text-[var(--text-color)]',
        [TYPES.error]: 'text-error dark:text-[var(--text-color)]',
        [TYPES.info]: 'text-info dark:text-[var(--text-color)]',
        [TYPES.warning]: 'text-warn dark:text-[var(--text-color)]',
        [TYPES.normal]: 'text-black dark:text-[var(--text-color)]',
        [TYPES.ghost]: 'text-black dark:text-[var(--text-color)]',
    };

    const SINGLE_ROW_TEXT_COLORS = {
        [TYPES.success]: 'text-success dark-text-[#00C275]',
        [TYPES.error]: 'text-error dark:text-[#FF4D4D]',
        [TYPES.info]: 'text-info dark:text-[var(--text-color)]',
        [TYPES.warning]: 'text-warn dark:text-[#FFB44A]',
        [TYPES.normal]: 'text-black dark:text-[var(--text-color)]',
        [TYPES.ghost]: 'text-black dark:text-[var(--text-color)]',
    };

    const BACKGROUND_COLORS = {
        [TYPES.success]: 'bg-[#EBFFEF] dark:bg-[#1A3C3C]',
        [TYPES.error]: 'bg-[#FFF2F2] dark:bg-[#3D2835]',
        [TYPES.info]: 'bg-[#EFF6FF] dark:bg-[#2A344D]',
        [TYPES.warning]: 'bg-[#FFF9EF] dark:bg-[#40352B]',
        [TYPES.normal]: 'bg-[#F8F9FB]',
        [TYPES.ghost]: 'bg-transparent',
    };

    const ICONS = {
        [TYPES.success]: <ImgTheme src={'/images/icons/announce-success.svg'}/>,
        [TYPES.warning]: <ImgTheme src={'/images/icons/announce-warning.svg'}/>,
        [TYPES.error]: <ImgTheme src={'/images/icons/announce-error.svg'}/>,
    };


    const ContentRender = () => showAnnounce ? <div className={`${className}`}>
        <div
            className={`${BACKGROUND_COLORS[TYPES[type]]} relative rounded-lg p-4 ${innerClassName} ${closable ? '!pl-9' : ''}`}>
            {
                closable && <IoCloseSharp className={
                    `absolute left-4 text-lg cursor-pointer ${SINGLE_ROW_TEXT_COLORS[TYPES[type]]}`
                } onClick={() => {
                    setShowAnnounce(false)

                    if (typeof onClose !== "undefined")
                        onClose()
                }}/>
            }
            <div>
                {
                    title && <span className={`font-bold ${
                        singleRow
                            ? MULTIPLE_TEXT_COLORS[TYPES[type]]
                            : TEXT_COLORS[TYPES[type]]
                    }`}>{title}</span>
                }
                {
                    text && <p
                        className={
                            `${title ? 'mt-3' : ''} ${
                                icon ? 'flex items-start gap-2' : ''
                            } mb-0 text-sm xl:text-base leading-6 ${
                                singleRow
                                    ? SINGLE_ROW_TEXT_COLORS[TYPES[type]]
                                    : TEXT_COLORS[TYPES[type]]
                            } ${textClassName}`}>
                        {icon && ICONS[TYPES[icon]]} {text}
                    </p>
                }
            </div>
            {
                !_.isNull(linkIcon) && linkIcon
            }
        </div>
    </div> : null

    return link ? <Link href={link.href} as={link.as}><a><ContentRender/></a></Link> : <ContentRender/>
}
